import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { RequestedAt } from '@open-tender/types'
import {
  fetchAllergens,
  fetchAnnouncementPage,
  fetchCustomerFavorites,
  fetchCustomerLoyalty,
  fetchCustomerOrders,
  fetchLocation,
  fetchMenu,
  fetchTags,
  openModal,
  selectCartTotal,
  selectCustomer,
  selectGroupOrderClosed,
  selectIsGroupOrder,
  // selectMenuVars,
  selectOrder,
  selectQuote,
  setIsGroupOrder,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import SidebarModal from '../../SidebarModal'
import { ItemSidebar } from '../../sidebarModals'
import { fetchedAnnouncementPages } from 'hooks'

const MenuPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [init, setInit] = useState(true)
  const { orderType, serviceType, requestedAt, revenueCenter } =
    useAppSelector(selectOrder)
  const revenueCenterId = revenueCenter?.revenue_center_id
  const groupOrderClosed = useAppSelector(selectGroupOrderClosed)
  const cartTotal = useAppSelector(selectCartTotal).toFixed(2)
  const { profile } = useAppSelector(selectCustomer)
  const { customer_id = null } = profile || {}
  const [customerId, setCustomerId] = useState<number | null>(null)
  const isGroupOrder = useAppSelector(selectIsGroupOrder)
  const quote = useAppSelector(selectQuote)
  const isCateringQuote = quote.order?.order_type === 'CATERING'
  const isMenuEditable = !isCateringQuote

  useEffect(() => {
    if (!revenueCenterId) {
      return navigate('/locations')
    } else if (groupOrderClosed) {
      return navigate('/review')
    } else if (!isMenuEditable) {
      return navigate('/checkout')
    } else if (init) {
      setInit(false)
      dispatch(fetchAllergens())
      dispatch(fetchTags())
      dispatch(fetchLocation({ revenueCenterId, cartTotal }))
      dispatch(
        fetchMenu({
          revenueCenterId,
          serviceType: serviceType ?? 'WALKIN',
          requestedAt: (requestedAt as RequestedAt) ?? 'asap',
        })
      )
      if (!fetchedAnnouncementPages['MENU']) {
        dispatch(fetchAnnouncementPage('MENU'))
        fetchedAnnouncementPages['MENU'] = true
      }
    }
  }, [
    init,
    revenueCenterId,
    orderType,
    serviceType,
    requestedAt,
    groupOrderClosed,
    dispatch,
    navigate,
    cartTotal,
    isMenuEditable,
  ])

  useEffect(() => {
    if (customer_id) {
      if (customer_id !== customerId) {
        setCustomerId(customer_id)
        dispatch(fetchCustomerLoyalty())
        dispatch(fetchCustomerFavorites())
        dispatch(fetchCustomerOrders(20))
      }
    } else {
      setCustomerId(null)
    }
  }, [customer_id, customerId, dispatch])

  useEffect(() => {
    if (isGroupOrder) {
      const reviewOrders = () => navigate(`/review`)
      dispatch(openModal({ type: 'groupOrder', args: { reviewOrders } }))
      dispatch(setIsGroupOrder(false))
    }
  }, [isGroupOrder, dispatch, navigate])

  return (
    <>
      <Outlet />
      <SidebarModal>
        <ItemSidebar />
      </SidebarModal>
    </>
  )
}

export default MenuPage
